<div id="procedimentos">
    <fieldset class="panel">
        <legend>Procedimentos Autorizados</legend>
        <div class="table-responsive">
        <table class="table table-sm table-striped table-hover">
            <thead>
              <tr>
                <th scope="col">Código</th>
                <th scope="col">Descrição do Benefício</th>
                <th scope="col">Qtde.</th>
                <th scope="col">Senha Autorização</th>
              </tr>
            </thead>
            <tbody *ngFor="let itemAtendimento of itensAtendimento">
              <tr>
                <td>{{ itemAtendimento.beneficio.cod_beneficio }}</td>
                <td>{{ itemAtendimento.beneficio.descricao }}</td>
                <td>{{ itemAtendimento.quantidade }}</td>
                <td>{{ itemAtendimento.num_Senha ?? '--' }}</td>
              </tr>
            </tbody>
          </table>
          </div>
    </fieldset>
</div>
